import { render, staticRenderFns } from "./AssignmentTimeline.vue?vue&type=template&id=06039f72&scoped=true&"
import script from "./AssignmentTimeline.vue?vue&type=script&lang=js&"
export * from "./AssignmentTimeline.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTimeline.vue?vue&type=style&index=0&id=06039f72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06039f72",
  null
  
)

export default component.exports